import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, radius, sizes, spacing } = redesignTheme;

/**
 * Canonical Redesign CTA button styles.
 * Spread these into feature makeStyles definitions and add local overrides
 * (width, flex, media queries...) after the spread when needed.
 */
export const primaryButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: spacing.xs,
  minHeight: sizes.buttonHeight,
  padding: '0 24px',
  border: 0,
  borderRadius: radius.sm,
  backgroundColor: colors.primaryDark,
  color: colors.white,
  cursor: 'pointer',
  fontFamily: fonts.opensansSemiBold,
  fontSize: fontSize.md,
  letterSpacing: 0.28,
  lineHeight: 'normal',
  boxSizing: 'border-box',
  '&:hover': {
    backgroundColor: colors.primaryDark,
    opacity: 0.92,
  },
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.6,
  },
} as const;

export const secondaryButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: spacing.xs,
  minHeight: sizes.buttonHeight,
  padding: '0 24px',
  border: `1px solid ${colors.border}`,
  borderRadius: radius.sm,
  backgroundColor: colors.white,
  color: colors.primaryDark,
  cursor: 'pointer',
  fontFamily: fonts.opensansSemiBold,
  fontSize: fontSize.md,
  letterSpacing: 0.28,
  lineHeight: 'normal',
  boxSizing: 'border-box',
  '&:hover': {
    backgroundColor: colors.hoverSurface,
  },
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.6,
  },
} as const;

export const buttonIconStyle = {
  width: 16,
  height: 16,
  flexShrink: 0,
} as const;
